import { toPairs } from 'rambda';
import { Refinements, AlgoliaFilters, notEmpty } from '@packages/common';

export const transformFacetFilters = (facetFilters: Refinements['facetFilters']): AlgoliaFilters['facetFilters'] =>
  toPairs(facetFilters)
    .map(([featureMapping, feature]) => feature.values.map((value) => `${featureMapping}:${value.featureValue}`))
    .filter(notEmpty);

export const transformNumericFilters = (
  numericFilters: Refinements['numericFilters'],
): AlgoliaFilters['numericFilters'] => {
  return toPairs(numericFilters).reduce((acc, next) => {
    const [featureMapping, filter] = next;
    return [...acc, `${featureMapping}>=${filter.value.min}`, `${featureMapping}<=${filter.value.max}`];
  }, [] as AlgoliaFilters['numericFilters']);
};

export const mapRefinementsToAlgoliaQuery = ({ facetFilters, numericFilters }: Refinements): AlgoliaFilters => ({
  facetFilters: transformFacetFilters(facetFilters),
  numericFilters: transformNumericFilters(numericFilters),
});

export default mapRefinementsToAlgoliaQuery;
